// extracted by mini-css-extract-plugin
export default {"small":"src-components-Navigation-Navigation__small","large":"src-components-Navigation-Navigation__large"};